/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit, ViewChild} from '@angular/core';
import {NgModule} from '@angular/core';
import {TreeNode, DataTableModule,TabViewModule,PanelModule,OverlayPanelModule,ButtonModule, TreeModule,InputTextModule,InputTextareaModule,CheckboxModule, MultiSelectModule, RadioButtonModule} from 'primeng/primeng';
import {RouterModule} from "@angular/router";
import {HttpModule} from "@angular/http";
import { FormsModule } from '@angular/forms';
import {BrowserModule} from "@angular/platform-browser";
import { MamAdminService } from '../../service/mam_service.component';
import { MdmPolicyTarget } from '../../model/mdmptgtmdl';
import { MDMPCONTCLS } from '../../model/mdmpolicycontrolclass';
import { MdmPolicyCondition } from '../../model/mdmpcond';
import { MdmPolicyControl } from '../../model/mdmpolicycontrol';
import {SelectItem} from "primeng/components/common/api";
import { MdmPolicy } from '../../model/mdmpolicy';
import {CompanyDropDownListModule} from "../../component/company-drop-down-list/company-drop-down-list.component";
import {TranslateServiceForm} from "../../translate/translate.service";
import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe"; // ADD THIS

@Component({
  selector: 'policy-apply-condition',
  templateUrl: 'policy_apply_condition_new.html'
})
export class PolicyApplyConditionNewComponent implements OnInit {
  private target_list : MdmPolicyTarget[] = [];
  private policy_control_list : MdmPolicyControl[] = [];
  private policy_condition_list : MdmPolicyCondition[] = [];
  private policy_control_class_list : MDMPCONTCLS[] = [];
  private mdm_policy_model_list : MdmPolicy[] = [];
  policyConditionList : any;

  mdmPolicy : MdmPolicy;

  selectedValues :any=[];

  platforms : SelectItem[];

  policyTreeNode : TreeNode[] = [];
  selectedVal : number = 0;
  selectedPolicy : any;

  getPolicyTargetLists : any;
  private translate:TranslateServiceForm;
  selectedCompany :any;
  @ViewChild('target') targetTab:any;
  constructor(private service : MamAdminService, private _translate: TranslateServiceForm, private logger : Logger) {

    this.translate = _translate;
  }


  ngOnInit() {
    /*this.getPolicyTarget('1',1,10);
     this.getPolicyConditionList(1,1,10);
     this.getPolicyControlList(1,1,10);*/

    this.platforms = [];
    this.platforms.push({label: 'ANY', value: 'ANY'});
    this.platforms.push({label: 'ANDROID', value: 'ANDROID'});
    this.platforms.push({label: 'IOS', value: 'IOS'});
    this.platforms.push({label: 'WINDOWS', value: 'WINDOWS'});

    //this.getPolicyTree(0);
  }


  //-------------------------------------Service--------------------------------------
  /*getPolicyTarget(pId:string, page:number, max:number){
   this.service.getPolicyTarget(pId, page, max).subscribe(
   value => {
   this.target_list = value.rows;
   this.logger.debug("target_list : ",  value);
   },
   error => {
   this.logger.error("-- error : " + error);
   },
   () => {
   this.logger.info("-- complate : ");
   }
   )
   }*/

  getPolicyConditionList(policyId:number, page:number, max:number) {
    this.service.getPolicyConditionList(policyId, page, max).subscribe(
      value => {
        this.policy_condition_list = value.rows;
        this.policyConditionList = value.rows;
        var controls = [];
        this.policyConditionList.forEach(conditionList =>{
          conditionList.controls.forEach(control => {
            control.controlClass.name = this.translate.instant("MdmPolicyControlName_"+control.controlClass.name);
            control.controlClass.value = this.translate.instant(control.controlClass.value);
          });
        });
        this.logger.debug("policy_condition_list : ", value);
      },
      error => {
        this.logger.error("-- error : " + error);
      },
      () => {
        this.logger.info("-- complate : ");
      }
    )
  }

  getPolicyTargetList(policyId: number,type : string, page?:number, size?:number ){
    this.service.getPolicyTargetList(policyId, type, page, size).subscribe(
      value => {
        this.logger.debug("getPolicyTargetLists : ", value);
        let temp = [];
        if(type=="group") {
            if(value && value.length>0){
                value.forEach(item => {
                    if(item.type=="VALUE"){
                        temp.push(item);
                    }
                })
            }
            this.getPolicyTargetLists = temp;
        }
        else if(type=="user") { this.getPolicyTargetLists = value.content;}
        else if(type=="device") { this.getPolicyTargetLists = value.content;}

      },
      error => {
        this.logger.error("-- error : " + error);
      },
      () => {
        this.logger.info("-- complate : ");
      }
    )
  }

  detailListForCondition(policyId : number){
    this.service.detailListForCondition(policyId).subscribe(
      value => {
        let In = {name:"",controls:[]};
        let Out = {name:"",controls:[]};
        let t = []; let c = [];

        this.policyConditionList = [];
        In.name = this.translate.instant('LANG_AccessInPolicy');
        t = value.IN;
        t.forEach(item =>{
          In.controls.push({controlClass:new controlClass(this.translate.instant("MdmPolicyControlName_"+item.name),item.platform,this.translate.instant(item.itemDefaultValue))});
        });

        this.policyConditionList.push(In);

        Out.name = this.translate.instant('LANG_AccessOutPolicy');
        t = value.OUT;
        t.forEach(item =>{
          Out.controls.push({controlClass:new controlClass(this.translate.instant("MdmPolicyControlName_"+item.name),item.platform,this.translate.instant(item.itemDefaultValue))});
        });

        this.policyConditionList.push(Out);

        this.logger.debug("완성한 출입정책 리스트들 : ",this.policyConditionList);
      },error => {
        this.logger.error("-- error : " + error);
      }
    )
  }

  getPassingCondtionDetailList(pId:number) {
    this.service.getPassingCondtionDetailList(pId).subscribe(
      value => {
        let obj = value;
        this.logger.debug("in : ",  value.IN);
        this.logger.debug("out : ",  value.OUT);

      },
      error => {
        this.logger.error("-- error : " + error);
      },
      () => {

      }
    )
  }

  getNewPolicyTree(companyId:number,type:number,diff:string){
    this.service.getNewPolicyTree(companyId,type,diff).subscribe(value =>{
        this.policyTreeNode = [];
        let item = value;
        if(item && item.length>0){
          item.forEach(val => {
            this.policyTreeNode.push({label:val.name,data:val});
          })
        }

      },
      error =>{this.logger.debug("error",error)});
  }

  //-----------------------------Event-------------------------------------------------------

  onTabChange(event){
    this.logger.debug(event);
  }

  onPolicySelect(event) {

    this.logger.debug("selected node : ",event);
    /*if(event.node.parent == null){  // select company
     return;
     }*/

    let tabArr = this.targetTab.tabs;
    for(let i=0;i<tabArr.length;i++){
      if(i==0){tabArr[i].selected=true;}
      else{tabArr[i].selected=false;}
    }

    this.selectedPolicy = event.node.data;
    this.getPolicyTargetList(this.selectedPolicy.id,"group");

    if(this.selectedVal == 0){

      this.getPolicyConditionList(this.selectedPolicy.id,1,30);
      //this.getPolicyControlList(this.selectedPolicy.id,1,30);
    }else {
      this.detailListForCondition(this.selectedPolicy.id);
      this.getPassingCondtionDetailList(this.selectedPolicy.id);
    }


  }

  treeClick(val){
    //this.getPolicyTree(val);
    if(val == 0)
      this.getNewPolicyTree(this.selectedCompany.id,val,"default");
    else
      this.getNewPolicyTree(this.selectedCompany.id,val,"inOut");
  }

  viewTypeTarget(event){
    if(this.selectedPolicy){
      if(event.index == 0) { this.getPolicyTargetList(this.selectedPolicy.id,"group"); }
      else if(event.index ==1){ this.getPolicyTargetList(this.selectedPolicy.id,"user",0,400);}
      else if(event.index ==2) { this.getPolicyTargetList(this.selectedPolicy.id,"device",0,400);}
    }else{
      alert(this.translate.instant('LANG_Left_Click_Tree'));
      return;
    }
  }

  onSelectedCompany(company) {
    this.selectedCompany = company;

    this.logger.debug("selectedComapny",this.selectedCompany);
    if(this.selectedVal == 0)
      this.getNewPolicyTree(this.selectedCompany.id,0,"default");
    else
      this.getNewPolicyTree(this.selectedCompany.id,1,"inOut");
    this.logger.debug("combo - select :" , this.selectedCompany);
  }

}

export class controlClass {
  name: string;
  platform : string;
  itemDefaultValue : string;

  constructor(name :string,platform:string,itemDefaultValue:string){
    this.name = name;
    this.platform = platform;
    this.itemDefaultValue = itemDefaultValue;
  }
}


@NgModule({
  imports: [DataTableModule,TabViewModule,PanelModule,BrowserModule,HttpModule, RouterModule,OverlayPanelModule,ButtonModule, TreeModule,InputTextModule,InputTextareaModule,FormsModule,CheckboxModule,MultiSelectModule,RadioButtonModule,CompanyDropDownListModule,TranslatePipeMoudle],
  exports: [PolicyApplyConditionNewComponent],
  declarations: [PolicyApplyConditionNewComponent],
  providers: [MamAdminService],
})
export class PolicyApplyConditionNewModule {
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/policy/policy_apply_condition_new.ts